/* ELITE — comportements légers.
   Les films ne se chargent et ne jouent que lorsqu'ils sont visibles. Sur ordinateur, les films
   des disciplines jouent au survol ; sur téléphone, quand ils sont à l'écran. Avec « réduire les
   animations » ou le mode économie de données, seule l'image fixe s'affiche. */
(function () {
  'use strict';

  var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var economie = !!(navigator.connection && navigator.connection.saveData);
  var survolPossible = window.matchMedia && window.matchMedia('(hover: hover) and (min-width: 990px)').matches;

  function charge(video) {
    if (video.dataset.elCharge) return;
    var sources = video.querySelectorAll('source[data-src]');
    for (var i = 0; i < sources.length; i++) sources[i].src = sources[i].getAttribute('data-src');
    video.load();
    video.dataset.elCharge = '1';
  }

  function joue(video) {
    charge(video);
    var promesse = video.play();
    if (promesse && promesse.catch) promesse.catch(function () {});
  }

  var observateur = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entrees) {
        entrees.forEach(function (entree) {
          if (entree.isIntersecting) joue(entree.target);
          else if (!entree.target.paused) entree.target.pause();
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 })
    : null;

  function init(racine) {
    var films = (racine || document).querySelectorAll('video[data-el-film]:not([data-el-init])');
    Array.prototype.forEach.call(films, function (video) {
      video.dataset.elInit = '1';
      video.addEventListener('playing', function () {
        var cadre = video.closest('.el-film');
        if (cadre) cadre.classList.add('is-pret');
      }, { once: true });

      if (reduit || economie) return;

      if (video.getAttribute('data-el-film') === 'survol' && survolPossible) {
        var zone = video.closest('[data-el-survol]') || video.parentElement;
        zone.addEventListener('mouseenter', function () { joue(video); });
        zone.addEventListener('mouseleave', function () { video.pause(); });
        zone.addEventListener('focusin', function () { joue(video); });
        zone.addEventListener('focusout', function () { video.pause(); });
        return;
      }

      if (observateur) observateur.observe(video);
      else joue(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
